/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import axios from 'axios';
import Cookies  from 'universal-cookie';

const RESOURCE_PAGE = "RemoveCookies";
const HOST_NAME = (typeof window !== 'undefined') ? window.location.hostname : '';
const ROOT_URI = 'webapp/wcs/stores/servlet/';

//Fixme : move axios call to wc api
export const  removeCommerceCookies = function (params) {
  const url = 'https://'+HOST_NAME+'/'+ROOT_URI +RESOURCE_PAGE;
  const method = 'get';
  const cookies = new Cookies();
  const headers = {
    'Content-Type': 'text/plain',
    sessionId: cookies.get('ShopperManagerEnterprise') || 'NO_ShopperManagerEnterprise_COOKIE',
  }
  const data = {};
  const config = {
    method,
    url,
    params: { ...params },
    headers: { ...headers },
    data,
    withCredentials: true,
};
return  axios(config);
   
};

export default removeCommerceCookies;